<div mat-dialog-title>
  <div class="d-flex justify-content-between">
      <p>Document Review</p>
      <i id="ibtClose" class="fa fa-times-circle pull-right" (click)="closeDialog()" aria-hidden="true"></i>
  </div>
</div>
<div style="width:100%;" *ngIf="showAll == false">

  <div class="row">
      <div class="setDocNoSty">
          <div style="width:40%;float:left;">
              <mat-form-field class="example-full-width">
                  <mat-label>Document No</mat-label>
                  <input matInput placeholder="Ex. Pizza">
              </mat-form-field>
          </div>
          <div style="width:40%;float: left;margin-left: 2.5%;">
              <mat-form-field class="example-full-width">
                  <mat-label>Document Title</mat-label>
                  <input matInput placeholder="Ex. Pizza">
              </mat-form-field>
          </div>
          <div style="width:10%; float: left;margin-left: 2.5%;">
              <mat-form-field class="example-full-width">
                  <mat-label>Revision</mat-label>
                  <input matInput placeholder="Ex. Pizza">
              </mat-form-field>
          </div>
      </div>
  </div>
  <div class="row">
      <div style="width :40%;margin-left: 2%;">
          <div style="width:50%;margin-left: 3%; margin-top: 8%;">
              <EIPAutoComplete ShowTextValueField='N' TextField="group_Name"  ValueField="group_Id" WaterMarkText="Document Status " [dataSource]='businessGroupList' setId="ddBusinessGrpId" (valueChange)='changeBusinessGroup($event)' [IsCascading]='true'>
              </EIPAutoComplete>
          </div>
      </div>
      <div style="width:58%;float:left">
          <div class="setDocNoSty">
              <div style="width:100%;">
                  <div style="width: 20%;float: left;">
                      <p style="margin-top: 13%; padding-top: 8%;">Reviewed On :</p>
                  </div>
                  <div style="width: 40%;float: left;">
                      <EIPDatePicker setid="txtRegisterDate" [Value]=sentdatevalue (selectedDate)='getSentOnValue($event)' (selectedTime)='getTimeValue($event)'>
                      </EIPDatePicker>
                  </div>
              </div>
          </div>
      </div>
  </div>
  <div style="width: 98%;margin: 0px auto;  margin-top: 2%;">
      <div>
          <mat-form-field class="example-full-width" appearance="fill">
              <mat-label>Comments / Remarks </mat-label>
              <textarea matInput placeholder="Ex. It makes me feel..."></textarea>
          </mat-form-field>
      </div>
  </div>
  <div>
      <button class="btn btn-primary" style="float: right; margin-bottom: 3%; margin-right: 2%;" (click)="sendMessage()"><i class="fa fa-save" title="Save" aria-hidden="true"></i>&nbsp;&nbsp;Save</button>
  </div>
</div>

<div *ngIf="showAll">
  <div class="row">
      <div class="setDocNoSty">
          <div style="width:15%;float:left">
              <EIPAutoComplete ShowTextValueField='N' TextField="group_Name"  ValueField="group_Id" WaterMarkText="Document Status" [dataSource]='businessGroupList' setId="ddBusinessGrpId" (valueChange)='changeBusinessGroup($event)' [IsCascading]='true'>
              </EIPAutoComplete>
          </div>
          <div style="width:22%;float:left;margin-left: 5%;">
              <div style="width: 27%;float: left;">
                  <p style="margin-top: 3%; padding-top: 16%;">Reviewed On :</p>
              </div>
              <div style="width:41%;float:left">
                  <EIPDatePicker setid="txtRegisterDate" [Value]=sentdatevalue (selectedDate)='getSentOnValue($event)' (selectedTime)='getTimeValue($event)'>
                  </EIPDatePicker>
              </div>
          </div>
          <div style="width: 55%;float: left;">
              <div style="width: 72%;">
                  <mat-form-field class="example-full-width" appearance="fill">
                      <mat-label>Comments / Remarks </mat-label>
                      <textarea matInput placeholder="Ex. It makes me feel..."></textarea>
                  </mat-form-field>
              </div>
          </div>
      </div>
  </div>
  <div style="width: 100%;display: inline-block;">
      <button class="btn btn-primary" style=" margin-bottom: 1%; margin-left: 2%;" (click)="sendMessage()">Apply All Documents</button>
  </div>
  <div class="row">
      <div style="width:98%; margin:0px auto;">
          <kendo-grid #distGrid [kendoGridBinding]="" [reorderable]="true" [sortable]="true" [resizable]="true" [filterable]="enableFilter" [pageSize]="10" [pageable]="true" (cellClick)="cellClickHandlerDistList($event)" (edit)="editRowDataDist($event)" (save)="UpdateRowDataDist($event)" (cancel)="cancelRowDataDist($event)">
              <ng-template kendoPagerTemplate>
                  <div class="k-pager-left">
                      <kendo-pager-info></kendo-pager-info>
                  </div>
                  <div class="k-pager-right">
                      <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
                      <kendo-pager-input></kendo-pager-input>
                      <kendo-pager-next-buttons></kendo-pager-next-buttons>
                  </div>
              </ng-template>
              <kendo-grid-column title="Sl.No." field="slno" width="60">
                  <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                      {{rowIndex+1}}
                  </ng-template>
              </kendo-grid-column>
              <kendo-grid-column title="Group" field="receiver_Group" width="80" visible="false">
              </kendo-grid-column>
              <kendo-grid-column title="Name" field="name" width="250">
              </kendo-grid-column>
              <kendo-grid-column title="Quantity" field="quantity" width="150">
              </kendo-grid-column>
              <kendo-grid-column title="Category" field="category" width="170">
              </kendo-grid-column>
              <kendo-grid-column title="Type" field="type" width="170">
              </kendo-grid-column>
              <kendo-grid-column title="Remarks" field="remarks" width="250">
              </kendo-grid-column>
              <kendo-grid-column title="Actions" width="200">
                  <ng-template kendoGridCellTemplate let-rowIndex="rowIndex" let-dataItem="dataItem">
                      <div>
                          <button kendoGridEditCommand class="k-grid-add-command">
                              <i class="fa fa-pencil icon-size mr-2" matTooltip="Edit" style="font-size: 20px;" id="" aria-hidden="true"></i>
                          </button>
                          <button kendoGridSaveCommand type="button" class="k-grid-add-command">
                              <i class="fa fa-save icon-size mr-2" matTooltip="Save" style="font-size: 20px;" id="" aria-hidden="true"></i>
                          </button>
                          <button kendoGridCancelCommand type="button" class="k-grid-add-command">
                              <i class="fa fa-times-circle icon-size mr-2" matTooltip="Cancel" style="font-size: 20px;" id="" aria-hidden="true"></i>
                          </button>
                      </div>
                  </ng-template>
              </kendo-grid-column>
          </kendo-grid>
      </div>
  </div>
  <div>
      <button class="btn btn-primary" style="float: right; margin-top: 1%; margin-right: 2%;" (click)="sendMessage()"><i class="fa fa-save" title="Save" aria-hidden="true"></i>&nbsp;&nbsp;Save</button>
  </div>
</div>